import React from 'react';
import { t } from '../../../../modules/infra/i18n';

const NoProducts = () => <p className="u-text-center u-mb-auto">{t('register:sale.no_products.message')}</p>;

export default NoProducts;
